module.exports = __webpack_public_path__ + "static/media/card1_2.41c5a1c4.png";